import React, { useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import api from '../api/client';

// Pagina del link ricevuto via email (/reimposta-password?token=…): sceglie la nuova password.
export default function ReimpostaPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get('token') || '';
  const [form, setForm] = useState({ password: '', conferma: '' });
  const [error, setError] = useState(token ? '' : 'Link non valido o scaduto.');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm(f => ({ ...f, [k]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (form.password.length < 8) { setError('La password deve essere di almeno 8 caratteri'); return; }
    if (form.password !== form.conferma) { setError('Le password non coincidono'); return; }
    setLoading(true);
    try {
      const r = await api.post('/auth/reimposta-password', { token, password: form.password });
      setSuccess(r.data.message);
      setTimeout(() => navigate('/login'), 2500);
    } catch (err) { setError(err.response?.data?.error || 'Errore'); }
    finally { setLoading(false); }
  };

  return (
    <div style={s.page}>
      <div style={s.card}>
        <div style={s.logo}>B-CHEERS ASD</div>
        <div style={s.sub}>NUOVA PASSWORD</div>
        <form onSubmit={handleSubmit} style={s.form}>
          <div style={s.field}>
            <label style={s.label}>NUOVA PASSWORD</label>
            <input style={s.input} type="password" value={form.password} onChange={set('password')} placeholder="Minimo 8 caratteri" autoComplete="new-password" required />
          </div>
          <div style={s.field}>
            <label style={s.label}>CONFERMA PASSWORD</label>
            <input style={s.input} type="password" value={form.conferma} onChange={set('conferma')} placeholder="Ripeti la password" autoComplete="new-password" required />
          </div>
          {error && <div style={s.error}>{error}</div>}
          {success && <div style={s.ok}>{success}</div>}
          <button type="submit" style={{ ...s.btn, opacity: (loading || !token || success) ? 0.7 : 1 }} disabled={loading || !token || !!success}>
            {loading ? 'SALVATAGGIO...' : 'SALVA LA NUOVA PASSWORD'}
          </button>
        </form>
        <div style={s.footer}>
          <Link to="/password-dimenticata" style={s.link}>Chiedi un nuovo link</Link> · <Link to="/login" style={s.link}>Login</Link>
        </div>
      </div>
    </div>
  );
}

const s = {
  page:   { minHeight:'100vh', background:'var(--bg)', display:'flex', alignItems:'center', justifyContent:'center', padding:'20px' },
  card:   { background:'var(--bg)', border:'1px solid var(--border)', borderRadius:'16px', padding:'48px 40px', width:'100%', maxWidth:'400px' },
  logo:   { fontFamily:"'Barlow Condensed'", fontSize: 'var(--font-size-title)', fontWeight:'800', color:'#F4600C', letterSpacing:'3px', textAlign:'center', marginBottom:'4px' },
  sub:    { fontSize:'var(--font-size-xs)', fontWeight:'700', color:'var(--text-dim)', letterSpacing:'2px', textAlign:'center', marginBottom:'24px' },
  desc:   { color:'var(--text-dim)', fontSize:'var(--font-size-sm)', marginBottom:'24px', lineHeight:'1.6', textAlign:'center' },
  form:   { display:'flex', flexDirection:'column', gap:'16px' },
  field:  { display:'flex', flexDirection:'column', gap:'7px' },
  label:  { fontSize: 'var(--font-size-xs)', letterSpacing:'2px', fontWeight:'700', color:'var(--text-dim)' },
  input:  { background:'var(--bg-input)', border:'1px solid var(--border2)', borderRadius:'10px', padding:'12px 14px', color:'var(--text)', fontSize:'var(--font-size-sm)', outline:'none', width:'100%', boxSizing:'border-box' },
  error:  { background:'#EF444420', border:'1px solid #EF444440', borderRadius:'8px', padding:'10px 14px', color:'#EF4444', fontSize:'var(--font-size-sm)', fontWeight:'600' },
  ok:     { background:'#22c55e20', border:'1px solid #22c55e40', borderRadius:'8px', padding:'10px 14px', color:'#22c55e', fontSize:'var(--font-size-sm)', fontWeight:'600' },
  btn:    { background:'#F4600C', color:'#fff', border:'none', borderRadius:'10px', padding:'14px', fontSize:'var(--font-size-sm)', fontWeight:'700', cursor:'pointer', letterSpacing:'1px', marginTop:'4px' },
  footer: { textAlign:'center', marginTop:'20px', fontSize:'var(--font-size-sm)', color:'var(--text-dim)' },
  link:   { color:'#F4600C', textDecoration:'none', fontWeight:'700' },
};
